import { checkAxiosData, getAxiosConfig } from 'fe-common'
import { from, tap, filter, concatMap, of } from 'rxjs'
import { handleMessages } from '../modules/client/utilities'

// const comp = require('../comp')
// const data = require('../promotion-prod-kb')

const convertPromotion = ({
  id,
  seoEncode,
  seoDecode,
  typeList,
  activityTitle,
  activitySummary,
  imgTinyPcUrl,
  imgTinyMobileUrl,
  imgListPcUrl,
  imgListMobileUrl,
  imgDetailPcUrl,
  imgDetailMobileUrl,
  activityContent,
  showActivityTime,
  activityStartTime,
  activityEndTime,
  activityStartTimeUTC,
  activityEndTimeUTC,
  utcHour,
  isActivityUrl,
  activityUrl,
  showButton,
  buttonText,
  buttonType,
  buttonUrl
}) => ({
  id,
  key: seoEncode,
  keyDecode: seoDecode,
  categories: typeList,
  title: activityTitle,
  description: activitySummary,

  // 首頁小Banner used
  indexImgPath: imgTinyPcUrl, // pc
  indexImgDescription: '',
  mobileIndexImgPath: imgTinyMobileUrl, // mobile

  // promotion list used
  listImgPath: imgListPcUrl, // pc
  listImgDescription: '',
  mobileListImgPath: imgListMobileUrl, // mobile
  mobileListImgDescription: '',

  // promotion detail used (for wc)
  detailImgPath: imgDetailPcUrl, // pc
  detailImgDescription: '',
  mobileDetailImgPath: imgDetailMobileUrl, // mobile

  content: activityContent,
  showTime: showActivityTime && showActivityTime === 'Y',
  startTime: activityStartTime,
  endTime: activityEndTime,
  utcStartTime: activityStartTimeUTC,
  utcEndTime: activityEndTimeUTC,
  utcHour,
  isExternalUrl: isActivityUrl && isActivityUrl === 'Y',
  externalUrl: activityUrl,

  showButton,
  buttonText,
  buttonType,
  buttonUrl
})

export default {
  state: () => ({
    promotions: [],
    selectedPromotion: {
      id: '',
      title: '',
      description: '',
      imgPath: '',
      imgDescription: '',
      imgDetailPath: '',
      imgDetailDescription: '',
      content: '',
      showTime: false,
      startTime: '',
      endTime: '',
      isExternalUrl: false,
      externalUrl: '',
      categories: [],
      showButton: '',
      buttonText: '',
      buttonType: '',
      buttonUrl: ''
    },
    promotionCategories: [],
    selectedPromotionCategory: ''
  }),
  actions: {
    getPromotions(context) {
      const { rootState, dispatch } = context
      // todo: 待後端提供多語系的優惠活動資料供串接即可移除
      // if (process.env.COMP_ID === 'kb') {
      //   return new Promise(resolve => {
      //     resolve({
      //       data: {
      //         data: data.promotions
      //       }
      //     })
      //   })
      // }
      return from(
        this.$axios.$post(
          `/webapi/preferential/search/list`,
          {
            deviceType: !rootState.isMobile ? 'PC' : 'MOBILE',
            languageCode: rootState.locale
          },
          getAxiosConfig(arguments[0])
        )
      )
        .pipe(
          filter(data =>
            checkAxiosData(data, {
              handleMessages: handleMessages({
                store: context
              })
            })
          ),
          tap(({ data }) => dispatch('updatePromotions', data))
        )
        .toPromise()
    },
    getPromotion({ state, dispatch }, payload) {
      // todo: 待後端提供多語系的優惠活動資料供串接即可移除
      // if (process.env.COMP_ID === 'kb') {
      //   return new Promise(resolve => {
      //     const promotion = data.promotions.find(
      //       promotion => payload === promotion.id
      //     )
      //     resolve({
      //       data: {
      //         data: promotion
      //       }
      //     })
      //   })
      // }
      return from(
        this.$axios.$post(
          `/webapi/preferential/search/one/${payload}`,
          {},
          getAxiosConfig(arguments[0])
        )
      ).toPromise()
    },
    getPromotionV2({ state, dispatch, rootState }, payload) {
      return from(
        this.$axios.$post(
          `/webapi/preferential/search/v2/one/${rootState.locale}/${payload}`,
          {},
          getAxiosConfig(arguments[0])
        )
      ).toPromise()
    },
    getPromotionCategories({ rootState, commit, dispatch }) {
      // todo: 待後端提供多語系的優惠活動資料供串接即可移除
      // if (process.env.COMP_ID === 'kb') {
      //   return new Promise(resolve => {
      //     resolve({
      //       data: {
      //         data: data.promotionCategories
      //       }
      //     })
      //   })
      // }
      return from(
        this.$axios.$post(
          `/webapi/preferential/search/type`,
          {
            deviceType: !rootState.isMobile ? 'PC' : 'MOBILE',
            languageCode: rootState.locale
          },
          getAxiosConfig(arguments[0])
        )
      ).toPromise()
    },
    updateSelectedPromotionCategory({ commit }, payload) {
      commit('SELECTED_PROMOTION_CATEGORY', payload)
    },
    updatePromotions({ commit, dispatch }, payload) {
      of(payload)
        .pipe(
          concatMap(payload => of((payload || []).map(convertPromotion))),
          tap(promotion => commit('PROMOTIONS', promotion))
        )
        .subscribe()
    },
    updateSelectedPromotion({ commit, dispatch, state }, payload) {
      of(payload)
        .pipe(
          concatMap(payload => of(convertPromotion(payload))),
          tap(promotion => commit('SELECTED_PROMOTION', promotion)),
          tap(promotion =>
            commit('headerModule/TITLE', promotion.title, {
              root: true
            })
          )
        )
        .subscribe()
    },
    initialSelectedPromotion({ commit }) {
      commit('SELECTED_PROMOTION', {
        id: '',
        title: '',
        description: '',
        listImgPath: '',
        listImgDescription: '',
        mobileListImgPath: '',
        detailImgPath: '',
        mobileDetailImgPath: '',
        detailImgDescription: '',
        content: '',
        showTime: false,
        startTime: '',
        endTime: '',
        isExternalUrl: false,
        externalUrl: '',
        categories: [],
        showButton: '',
        buttonText: '',
        buttonType: '',
        buttonUrl: ''
      })
    }
  },
  mutations: {
    PROMOTIONS(state, payload) {
      state.promotions = payload
    },
    SELECTED_PROMOTION_CATEGORY(state, payload) {
      state.selectedPromotionCategory = payload
    },
    SELECTED_PROMOTION(state, payload) {
      state.selectedPromotion = payload
    },
    PROMOTION_CATEGORIES(state, payload) {
      state.promotionCategories = payload
    }
  },
  getters: {
    promotions(state) {
      return state.promotions
    },
    selectedPromotionCategory(state) {
      return state.selectedPromotionCategory
    },
    selectedPromotion(state) {
      return state.selectedPromotion
    },
    promotionCategories(state) {
      return state.promotionCategories
    }
  }
}
